import "./Eid.scss"
import eid_icon from "../../Assets/Images/eid_kaartlezer.png";
import itsme_icon from "../../Assets/Images/itsme_icon.png";
import bericht_icon from "../../Assets/Images/bericht_icon.png";
import mail_icon from "../../Assets/Images/mail_icon.png";
import tooltip from "../../Assets/Images/tooltip.png"
import React from 'react';
import { useForm } from 'react-hook-form';
import { useLogin, useSession, useSuccesfullLogin } from '../../Contexts/Authprovider';
import { useNavigate  } from "react-router-dom";
import { useCallback, useEffect } from "react";


export default function Eid(){
    const navigate = useNavigate();
    const { handleSubmit } = useForm();
    const login = useLogin();
    const succesfullLogin = useSuccesfullLogin();
    const { isAuthed } = useSession();
    const handleLogin = useCallback(async({username,password})=>{
        const user = await login('ExternalUser', 'password123');
        if (user) {
            succesfullLogin(user);
            await timeout(500)
            navigate("/")
        }
    },[login, navigate, succesfullLogin]);

    useEffect(()=>{
        if (isAuthed) {
            return navigate('/');
          }
    },[isAuthed, navigate])

    function timeout(delay) {
        return new Promise( res => setTimeout(res, delay) );
    }
    return (
        <div className="EIDContainer">
        <div className="Grid-Box">
                <div className="eid-box row-eq-column" required data-cy="eid_box" onClick={handleSubmit(handleLogin)}>
                    <div className="eid-icon">
                        <img src={eid_icon} alt="eid_icon" required data-cy="eid_icon"></img>
                        <div className="tooltip">
                            <img src={tooltip} alt="eid_tooltip" className="tooltip" required data-cy="eid_tooltip"></img>
                            <span>What do you need? Your eID, your PIN, a card reader and the eID software.</span>
                        </div>
                    </div> 
                    <div className="eid-content">
                            <h3 className="eid-titel" required data-cy="eid_titel">Sign in</h3>
                            <div className="eid-subtext" required data-cy="eid_subtext">with eID cardreader</div>
                    </div>               
                </div>
                <div className="eid-box row-eq-column" required data-cy="itsme_box" onClick={handleSubmit(handleLogin)}>
                    <div className="itsme-icon">
                        <img src={itsme_icon} alt="itsme_icon" required data-cy="itsme_icon"></img>
                        <div className="tooltip">
                            <img src={tooltip} alt="itsme_tooltip" className="tooltip" required data-cy="itsme_tooltip"></img>
                            <span>To use this login option, you must already have registred with itsme.</span>
                        </div>
                    </div> 
                    <div className="eid-content">
                            <h3 className="eid-titel" required data-cy="itsme_titel">Sign in</h3>
                            <div className="eid-subtext" required data-cy="itsme_subtext">with ItsMe</div>
                    </div>               
                </div>
                <div  className="eid-box row-eq-column" required data-cy="message_box" onClick={handleSubmit(handleLogin)}>
                    <div className="message-icon">
                        <img src={bericht_icon} alt="message_icon" required data-cy="message_icon"></img>
                        <div className="tooltip">
                            <img src={tooltip} alt="message_tooltip" className="tooltip" required data-cy="message_tooltip"></img>
                            <span>First enter your username and password from My digital keys and click next to then enter the one-time code.</span>
                        </div>
                    </div> 
                    <div className="eid-content">
                            <h3 className="eid-titel" required data-cy="message_titel">Sign in</h3>
                            <div className="eid-subtext" required data-cy="message_subtext">with security code via message</div>
                    </div>               
                </div>
                <div  className="eid-box row-eq-column" required data-cy="mail_box" onClick={handleSubmit(handleLogin)}>
                    <div className="mail-icon">
                        <img src={mail_icon} alt="mail_icon" required data-cy="mail_icon"></img>
                        <div className="tooltip">
                            <img src={tooltip} alt="mail_tooltip" className="tooltip" required data-cy="mail_tooltip"></img>
                            <span>First enter your username and password from My digital keys and click next to then enter the one-time code.</span>
                        </div>
                    </div> 
                    <div className="eid-content">
                            <h3 className="eid-titel" required data-cy="mail_titel">Sign in</h3>
                            <div className="eid-subtext" required data-cy="mail_subtext">with security code via email</div>
                    </div>               
                </div>
        </div>       
        </div>
    );
}
